import { Component, EventEmitter, Output, Input, OnInit } from '@angular/core'
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms'
import { debounceTime } from 'rxjs/operators'
import {
	MatAutocomplete,
	MatAutocompleteModule,
	MatAutocompleteSelectedEvent,
} from '@angular/material/autocomplete'
import { MatFormField, MatInput, MatLabel } from '@angular/material/input'
import { NgStyle } from '@angular/common'
import { MatIcon } from '@angular/material/icon'

export type AutoCompleteOptionValue = string | number

export interface AutoCompleteOption {
	value: AutoCompleteOptionValue
	label: string
}

@Component({
	selector: 'autocomplete-component',
	templateUrl: './Autocomplete.Component.html',
	imports: [
		MatFormField,
		NgStyle,
		MatIcon,
		MatLabel,
		MatInput,
		MatAutocomplete,
		FormsModule,
		ReactiveFormsModule,
		MatAutocompleteModule,
	],
})
export class AutocompleteComponent implements OnInit {
	@Input() public options: AutoCompleteOption[]

	@Input() public placeholder: string

	@Input() public prefixIcon: string

	@Input() public suffixIcon: string

	@Input() protected readonly disabled: boolean

	@Input() private readonly resetOnCompletion: boolean

	@Input() private readonly filter: (string) => Promise<void>

	@Output() private readonly optionSelected =
		new EventEmitter<AutoCompleteOptionValue>()

	public control = new FormControl()

	public ngOnInit(): void {
		this.control.valueChanges
			.pipe(debounceTime(500))
			.subscribe(async (value) => this.filter(value))
	}

	public selectOption = (event: MatAutocompleteSelectedEvent): void => {
		this.optionSelected.emit(event.option.value)

		if (this.resetOnCompletion) {
			this.control.setValue('')
		}
	}

	public itemTracker = (index: number) => index
}
